"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NerdJoke = exports.JokeButton = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pixelated = require("../utilities/pixelated.api");
require("./pixelated.nerdjoke.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class NerdJoke extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadJoke", () => {
      this.timePassed = 0;
      this.timeLeft = this.TIME_LIMIT;
      this.timerInterval = null;
      clearInterval(this.jokeInterval);
      this.jokeInterval = setInterval(() => {
        if (!this.timePaused) {
          this.loadJoke();
        }
      }, this.TIME_LIMIT * 1000);
      const myURL = 'https://vvqyc1xpw6.execute-api.us-east-2.amazonaws.com/prod/nerdjokes?';
      const myURLProps = {
        command: '%2Fnerdjokes',
        text: 'getjokejson'
      };
      const myMethod = 'GET';
      (0, _pixelated.getXHRData)((0, _pixelated.generateURL)(myURL, myURLProps), myMethod, jokeData => {
        const myJokeData = jokeData;
        this.setState({
          joke: myJokeData
        });
      });
    });
    _defineProperty(this, "formatTimeLeft", time => {
      const minutes = Math.floor(time / 60);
      let seconds = time % 60;
      if (seconds < 10) {
        seconds = "0".concat(seconds);
      }
      return "".concat(minutes, ":").concat(seconds);
    });
    _defineProperty(this, "startTimer", () => {
      this.timerInterval = setInterval(() => {
        if (!this.timePaused) {
          this.timePassed = this.timePassed += 1;
          this.timeLeft = this.TIME_LIMIT - this.timePassed + 1;
          const myWidth = 1 / this.TIME_LIMIT * this.timeLeft * 100 + '%';
          document.getElementById('joke-timer-label').innerHTML = this.formatTimeLeft(this.timeLeft);
          document.getElementById('joke-timer-path-elapsed').style.width = myWidth;
        }
      }, 1000);
    });
    _defineProperty(this, "pauseTimer", () => {
      this.timePaused = !this.timePaused;
    });
    this.TIME_LIMIT = 15;
    this.timePassed = 0;
    this.timePaused = false;
    this.timeLeft = this.TIME_LIMIT;
    this.timerInterval = null;
    this.jokeInterval = null;
    this.state = {
      joke: {
        question: '',
        answer: ''
      }
    };
  }
  componentDidMount() {
    this.loadJoke();
    this.startTimer();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "nerdjoke grid12"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "grid6"
    }, /*#__PURE__*/_react.default.createElement(JokeButton, {
      clickFunction: this.pauseTimer,
      buttonText: "||  /  >"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid6"
    }, /*#__PURE__*/_react.default.createElement(JokeButton, {
      clickFunction: this.loadJoke,
      buttonText: "Next Joke ->"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "joke-timer grid12"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "grid10"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "joke-timer-svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      id: "joke-timer-path-elapsed"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid2",
      id: "joke-timer-label"
    }, this.formatTimeLeft(this.timeLeft))), /*#__PURE__*/_react.default.createElement("div", {
      className: "joketext grid12"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "Q: "), /*#__PURE__*/_react.default.createElement("span", {
      className: "question"
    }, " ", this.state.joke.question, " ")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, "A: "), /*#__PURE__*/_react.default.createElement("span", {
      className: "answer"
    }, " ", this.state.joke.answer, " "))));
  }
}

/* ========== CAROUSEL SLIDER ARROW ========== */
exports.NerdJoke = NerdJoke;
class JokeButton extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'jokebutton',
      onClick: this.props.clickFunction
    }, this.props.buttonText);
  }
}
exports.JokeButton = JokeButton;
_defineProperty(JokeButton, "propTypes", {
  clickFunction: _propTypes.default.func.isRequired,
  buttonText: _propTypes.default.string.isRequired
});